const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<ul class="demo-favicon-tabs">
  `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.createRange(1, 2));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`i`] = __value__;
                    this.echo(`    <li>
      `);
                    if ((context.has(`dev`) ? context.get(`dev`) : null)) {
                        this.echo(`        `);
                        this.echo(this.include(context, this.source, `@cloudfour/assets/favicons/icon-dev.svg.twig`, undefined, true, false, 5));
                        this.echo(`      `);
                    }
                    else {
                        this.echo(`        `);
                        this.echo(this.include(context, this.source, `@cloudfour/assets/favicons/icon.svg.twig`, undefined, true, false, 7));
                        this.echo(`      `);
                    }
                    this.echo(`      Cloud Four
      `);
                    if ((context.has(`dev`) ? context.get(`dev`) : null)) {
                        this.echo(`        (Dev)
      `);
                    }
                    this.echo(`    </li>
  `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('i');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`</ul>
`);
            }

            getTemplateName() {
                return `efb8aa584cd8651c7a5d535ca0195dc16fb5d78725771c4c0753e8a513f6430b`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `efb8aa584cd8651c7a5d535ca0195dc16fb5d78725771c4c0753e8a513f6430b`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'efb8aa584cd8651c7a5d535ca0195dc16fb5d78725771c4c0753e8a513f6430b');

let template = env.loadTemplate('efb8aa584cd8651c7a5d535ca0195dc16fb5d78725771c4c0753e8a513f6430b');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/design/demo/favicon-tabs.twig", args: context }
     );
     return rendered;;
};